import { simpleLookupConfig } from "../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../lookupManagement";

export const vsObjectName = "contractNumberType";

const url = "/api/contract/ContractNumberType";

export const contractNumberTypeLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Number Type",
    namePlural: "Number Types",
    url,
    defaultSort: "Name",
  }
);
